const statuses = {
  under_construction: {
    name: 'under_construction',
    icon: 'img/campaigns/work.svg'
  },
  inviting: {
    name: 'inviting',
    icon: 'img/campaigns/add.svg'
  },
  waiting_for_payment: {
    name: 'waiting_for_payment',
    icon: 'img/campaigns/pay.svg'
  },
  in_progress: {
    name: 'in_progress',
    icon: 'img/campaigns/infinity.png'
  },
  completed: {
    name: 'completed',
    icon: 'img/campaigns/ok.svg'
  },
  canceled: {
    name: 'canceled',
    icon: 'img/campaigns/x.svg'
  },
  interrupted: {
    name: 'interrupted',
    icon: 'img/campaigns/no.svg'
  }
}

export default statuses
